import styled from 'styled-components';
import { BREAK_POINT } from '../../config/constants';

export const ContactWrapper = styled.div`
	padding-top: 12px;
	.btn-area {
		padding-top: 12px;
		display: flex;
		> button {
			flex: 1;
			margin-right: 12px;
		}
		> .ant-btn-primary {
			flex: 2;
			margin-right: 0;
		}
	}
`;

export const InfoWrapper = styled.div`
	position: relative;
	.vault-type {
		padding-top: 12px;
		.ant-select {
			width: 100%;
		}
	}
	.arrow {
		position: absolute;
		top: 50%;
		transform: translateY(-40%) rotate(45deg);
		width: 25px;
		height: 25px;
		cursor: pointer;
		&.left {
			left: -10px;
			border-left: 2px solid #393939;
			border-bottom: 2px solid #393939;
		}
		&.right {
			right: -10px;
			border-right: 2px solid #393939;
			border-top: 2px solid #393939;
		}
	}
	.vault-info {
		display: flex !important;
		padding: 12px 8px;
		.vault-info-img {
			max-width: 200px;
			height: 200px;
			display: block;
			margin-right: 12px;
		}
		.vault-info-desc {
			flex: 1;
			font-size: 12px;
			height: 200px;
			position: relative;
			p {
				margin-bottom: 0;
			}
			.cost-box {
				b {
					font-size: 24px;
				}
			}
		}
	}
	.btn-area {
		display: flex;
		> button {
			flex: 1;
			margin-right: 12px;
		}
		> .ant-btn-primary {
			flex: 2;
			margin-right: 0;
		}
	}
	@media (max-width: ${`${BREAK_POINT}px`}) {
		.vault-info {
			.vault-info-img {
				max-width: 120px;
				height: 120px;
			}
			.vault-info-desc {
				height: auto;

				.cost-box {
					position: static;
				}
			}
		}
	}
`;

export const WarningWrapper = styled.div`
	text-align: center;
	.upgrade-img {
		padding-top: 12px;
		img {
			width: 80px;
		}
	}
	h3 {
		font-size: 24px;
	}
	.btn-area {
		display: flex;
		> button {
			flex: 1;
			margin-right: 12px;
		}
		> .ant-btn-primary {
			flex: 2;
			margin-right: 0;
		}
	}
	@media (max-width: ${`${BREAK_POINT}px`}) {
		h3 {
			font-size: 16px;
		}
	}
`;

export const PickMonthWrapper = styled.div`
	position: relative;
	.ant-radio-group {
		width: 100%;
		span.ant-radio + * {
			flex: 1;
		}
		p {
			margin: 0;
		}
		.discount-label {
			position: absolute;
			right: 0;
			top: 24px;
		}
	}
`;
